module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap-num"
  }, [_vm._v("Three")]), _vm._v(" "), _c('h3', {
    staticClass: "chap-title"
  }, [_vm._v("Disappearance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I looked with widened eyes. My heart was still. The room was flooded with a subdued green intensity. The smell of herbaceous earth overwhelmed my senses. The forest darkness compacted into corners of the room. And, condensing beside Dad, as if the green were alive, its own light, contracting into an unmistakable form – was the leopard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was old. Its eyes were like blue jewels. And it sat peacefully at Dad’s feet. The leopard was phosphorescent, spreading no shadows, as if it had come to the end of its dreaming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then something odd occurred to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are you awake, Dad?’ I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The light of the great animal flickered. Dad was silent. I asked the question again, louder. Mum turned on the bed. For an instant the room darkened again. Then the green radiance glowed, filling out the place. I got up from my mat. As I neared Dad, the leopard’s illumination dimmed. I stopped, and whispered hard into his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARE YOU AWAKE, DAD")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WHAT")]), _vm._v("?’ he cried, jumping up suddenly, plunging the room into night.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leopard was gone. I stayed silent for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, as if he had woken into sleep, Dad brushed past me, muttering something about seeing things for the first time. He went out of the room. For a moment I was confused. Then I went out after him, ran to the housefront, and looked both ways. Dad wasn’t anywhere. I went to the backyard, but he wasn’t there either. I hurried to the street again, ran one way, then another. It was very strange, and the thought scared me, but it seemed as if Dad simply stepped out of our door, and out of reality. I went back to the room and waited for him. While I waited it occurred to me that Dad had been talking from his sleep. I had entered another of his dreams.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037bc70d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/009_Part01Sub01Ch03.vue
// module id = 90
// module chunks = 0